import { Layout, Model } from 'flexlayout-react';
import { DocumentData } from '../../context/DocumentDataProvider';
import { findReactFlowTabset } from './FindReactFlowTabset';

// Función para agregar un nuevo heatmap
export const handleAddHeatMap = (
    setDocumentData: React.Dispatch<React.SetStateAction<DocumentData>>,
    setPlots: React.Dispatch<React.SetStateAction<Map<string, any>>>,
    layoutModel: Model,
    setLayoutModel: React.Dispatch<React.SetStateAction<Model>>,
    uniqueId: string,
    heatMapName: string,
) => {
    let newHeatMapName = '';
    setPlots(prev => {
        const updated = new Map(prev);
        const newIndex = (prev?.size || 0) + 1;
        newHeatMapName = heatMapName || `Heatmap ${newIndex}`;
        // Datos de ejemplo para el heatmap
        const newHeatMap = {
            id: uniqueId,
            data: [{
                z: [
                    [1, 20, 30, 40],
                    [20, 1, 60, 70],
                    [30, 60, 1, 80],
                    [40, 70, 80, 1]
                ],
                x: [1, 2, 3, 4],
                y: [1, 2, 3, 4],
                type: 'heatmap',
                colorscale: 'Viridis',
                name: newHeatMapName,
            }],
            layout: {
                title: { text: 'Heatmap Example' },
                xaxis: { title: { text: 'X axis' } },
                yaxis: { title: { text: 'Y axis' } },
            },
        };
        updated.set(uniqueId, newHeatMap);
        return updated;
    });

    setLayoutModel(prevModel => {
        const json = prevModel.toJson();
        const tabset = findReactFlowTabset(json.layout);
        if (tabset) {
            const newTab = {
                id: uniqueId,
                type: 'tab',
                name: newHeatMapName,
                component: 'HeatMapTab',
                config: {},
                enableClose: false,
                enableDrag: true,
                enableRename: true,
                children: [],
                icon: 'chart-heat-map.svg',
            };
            tabset.children.push(newTab);
        } else {
            console.warn('No tabset found in layout JSON to add the heatmap tab.');
        }
        return Model.fromJson(json);
    });
};